import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  model,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import * as uuid from 'uuid';
import { FormEntry } from '@core/interfaces/form-entry';
import { TableService } from '@core/services/table.service';
import { FormService } from '@core/services/form.service';
import {
  Form,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
} from '@angular/forms';
import { AnyFormClass } from '@core/types';
import { NgComponentOutlet } from '@angular/common';

export class FormOptions {
  id?: string = uuid.v4();
  form?: FormGroup;
  name?: string;
  data?: FormEntry[];
  onSubmit?: () => void;
  formElement?: NgForm;

  constructor(args: FormOptions) {
    this.id = args?.id || uuid.v4();
    this.form = new FormGroup({});
    this.name = args?.name || '';
    this.data = args?.data || [];
    this.onSubmit = args?.onSubmit;
    this.formElement = args?.formElement;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-form',
  imports: [NgComponentOutlet, FormsModule, ReactiveFormsModule],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent<T extends AnyFormClass> implements OnInit, AfterViewInit {
  @ViewChild('frm') protected formElement?: NgForm;
  //protected form = new FormGroup({});
  private formBuilder = inject(FormBuilder);
  protected dataLoaded: boolean = false;

  options = model(new FormOptions({}));

  ngOnInit(): void {
    this.options().form = this.buildForm(this.options().data!);
    this.dataLoaded = true;
    this.options.set(this.options());
  }

  ngAfterViewInit(): void {
    this.options().formElement = this.formElement;
  }

  buildForm(entries: FormEntry[]): FormGroup {
    entries.map((entry, index) => {
      if (entry.children && entry.children?.length) {
        this.options().form!.addControl(
          entry.name || 'formGroup' + index,
          this.buildForm(entry.children)
        );
      } else {
        this.options().form!.addControl(
          entry.name || 'formControl' + index,
          new FormControl(
            { value: entry.componentOptions?.value, disabled: false },
            entry.validators
          )
        );
        this.options().form!.addValidators(entry.validators!);
      }
      entry.componentOptions!.formGroup = this.options().form;
    });

    return this.options().form!;
  }
  showValidatinErrors() {}

  clearForm = () => {
    this.formElement?.resetForm();
  };

  protected readonly Object = Object;
}
